import React, { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import { any, toLower } from "ramda";
import { useCurrentOrgId, useIsAdmin } from "../../auth/authUtils";

import Grid from "@mui/material/Grid";
import { useSubscriptions } from "../../manage-subscriptions/subscriptionService";

const useStyles = makeStyles(theme => ({
  badge: {
    width: 16,
    height: 16,
    borderRadius: 20,
    marginLeft: 10,
    marginRight: 10,
  },

  badgeXs: {
    marginLeft: 0,
    marginRight: 5,
  },

  lg: {
    width: 16,
    height: 16,
  },

  sm: {
    width: 14,
    height: 14,
  },

  xs: {
    width: 10,
    height: 10,
  },

  active: {
    backgroundColor: "green",
  },

  inactive: {
    backgroundColor: "#999",
  },

  deleted: {
    backgroundColor: theme.palette.deleted,
  },

  activeLabel: {
    fontWeight: 700,
    color: theme.palette.success.main,
  },

  inactiveLabel: {
    fontWeight: 700,
    fontStyle: "italic",
    color: theme.palette.secondary.contrastText,
  },

  deletedLabel: {
    fontWeight: 700,
    color: theme.palette.deleted,
  },

  labelOnly: {
    width: "auto",
  },
}));

const StatusBadge = ({ labelOnly = false, label, status, size }) => {
  const classes = useStyles();
  const isAdmin = useIsAdmin();

  const hideSwitch = isAdmin || labelOnly;
  return (
    <Grid
      container
      justifyContent={hideSwitch ? "flex-start" : "space-between"}
      alignItems="center"
      className={clsx({
        [classes.labelOnly]: hideSwitch,
      })}
    >
      <div
        className={clsx(
          classes.badge,
          classes[size],
          classes[toLower(status)],
          {
            [classes.badgeXs]: size === "xs",
          },
        )}
      />
      <Grid item className={`${classes[`${toLower(status)}Label`]}`}>
        {label}
      </Grid>
    </Grid>
  );
};

// TODO: might use later for sharing modules
// Display Live/Draft status on a per-org basis
export const ModuleStatusBadge = ({ module, renderLabel, ...badgeProps }) => {
  const currentOrgId = useCurrentOrgId();
  const isAdmin = currentOrgId === "admin";
  const subscriptions = useSubscriptions(
    isAdmin ? null : currentOrgId,
    module.id,
    true,
    true,
    false,
    null,
    null,
    null,
    0,
    "all",
  );

  const [status, setStatus] = useState("INACTIVE");
  useEffect(() => {
    if (subscriptions.isSuccess) {
      if (!isAdmin) {
        const isActiveForOrg = any(
          sub => sub.organizationId === currentOrgId && sub.status === "ACTIVE",
          subscriptions.data,
        );
        console.log(isActiveForOrg);
        setStatus(isActiveForOrg ? "ACTIVE" : module.status);
      } else {
        setStatus(module.status);
      }
    }
  }, [
    currentOrgId,
    subscriptions.isSuccess,
    subscriptions.data,
    isAdmin,
    module.status,
  ]);

  if (subscriptions.isLoading || subscriptions.isError) {
    return null;
  }

  return (
    <StatusBadge {...badgeProps} label={renderLabel(status)} status={status} />
  );
};

export default StatusBadge;
